<div class="scenario-panel">
  <div class="header">
    <h2 class="title">Produktkatalog</h2>
  </div>
  <div class="body" cdkScrollable>
    <div class="search-form" *ngIf="recommended || nonrecommended">
      <mat-form-field class="search-full-width">
        <input #lampSearch type="text" placeholder="Freitextsuche" aria-label="Number" matInput [formControl]="searchControl" [matAutocomplete]="auto" />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFormat">
          <mat-option *ngFor="let option of filteredOptions | async; trackBy: trackByFnOption" [value]="option">
            {{ option.suggestedModel }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <app-notification-card
      type="info"
      text="{{ 'module.energyMap.productCatalog.validationNoProductsFoundMessage' | translate }}"
      *ngIf="
        (recommended === null || recommended === undefined || recommended.length <= 0) &&
        (nonrecommended === null || nonrecommended === undefined || nonrecommended.length <= 0)
      "
      class="header description-message app-notification-card"
    >
    </app-notification-card>
    <div class="products" *ngIf="recommended !== null && recommended !== undefined && recommended.length > 0">
      <div class="group">{{ 'module.energyMap.productCatalog.recommendedText' | translate }}</div>
      <div class="cards">
        <app-lamp-card
          *ngFor="let lamp of recommended; trackBy: trackByFnRecommended"
          [lamp]="lamp"
          [active]="lamp === selectedLamp"
          (cardSelect)="selectModel($event)"
          class="lamp-card"
        ></app-lamp-card>
      </div>
    </div>
    <div
      class="products"
      *ngIf="nonrecommended !== null && nonrecommended !== undefined && nonrecommended.length > 0 && !!authService.permissions.STREETLIGHT_PLANNER_LED_RETROFIT"
    >
      <div class="group">{{ 'module.energyMap.productCatalog.moreOptionText' | translate }}</div>
      <div class="cards">
        <app-lamp-card
          *ngFor="let lamp of nonrecommended; trackBy: trackByFnNonRecommended"
          [lamp]="lamp"
          [active]="lamp === selectedLamp"
          (cardSelect)="selectModel($event)"
          class="lamp-card"
        ></app-lamp-card>
      </div>
    </div>
  </div>

  <div class="footer">
    <button class="btn btn-outline-primary" [class.-disabled]="selectedLamp === null" (click)="save()"><span class="fa fa-check-circle"></span> Fertig</button>
  </div>
  <button class="btn btn-primary btn-close" (click)="close()">
    <img class="x-icon" alt="close-icon" src="../../../../assets/icons/close-icon-white.svg" />
  </button>

  <div class="overlay" *ngIf="isProductLoading">
    <span class="fa fa-spinner fa-spin fa-3x"></span>
  </div>
</div>
